import { Chart } from './chart_class';
import { getCssVariableValue } from '../utils';

export class GaugeChart extends Chart {
    constructor() {
        super();
        this.options = {
            ...super.getParentChartOption(),
            // xAxis   : {},
            yAxis: {
                show:false,
            },
            xAxis: {
                show:false,
            },
            series  : [],
            // center  : ["50%", "50%"],
            tooltip : {
                trigger: 'axis',
                // formatter: this._getTooltipFormatter(),
            },
        };
    }

    setSeries(series) {
        this.options.series = series
    }

    getOptions() {
        return this.options;
    }

    getSeriseOpitons() {
        return {
            type       : 'gauge',
            startAngle : 180,
            endAngle   : 0,
            center     : ['50%', '80%'],
            silent     : true,
            min        : -100,
            max        : 100,
            radius     : "120%",
            axisLine   : {
                lineStyle: {
                    width: 20,
                    color: [
                        [0.3, getCssVariableValue("--red-200")],
                        [0.7, getCssVariableValue('--orange-100')],
                        [1,   getCssVariableValue('--blue-100')]
                    ]
                }
            },
            pointer : {
                length       : '30%',
                width        : 8,
                offsetCenter : [0, '-74%'],
                itemStyle    : {
                    color        : 'white',
                },
                icon: "roundRect"
            },
            axisTick: {
                // distance  : -30,
                length    : 4,
                // splitNumber: 6,
                lineStyle : {
                    color     : '#fff',
                    width     : 0
                }
            },
            splitLine : {
                // distance   : -50,
                length     : 0,
                lineStyle  : {
                    color        : '#fff',
                    width    : 7
                }
            },
            axisLabel: {
                color     : 'inherit',
                distance  : -25,
                fontSize  : 14,
                rotate    : "tangential",
            },
            detail: {
                fontSize       : window.innerWidth <= 768 ? 20 : 30,
                offsetCenter   : [0, "-8%"],
                valueAnimation : true,
                formatter      : '{value} %',
                color          : getCssVariableValue('--gray-000'),
            },
            data : [],
        }
    }
}